// export const url = 'http://localhost:3001';
// export const url = 'http://37.139.6.18:3001';
// export const host = 'http://37.139.6.18:3001';

// local
// export const url = 'http://157.245.230.31:3001';
// export const host = 'http://157.245.230.31:3001';
export const url = '';
export const host = '';

